import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const ExchangeHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden">
      <div className="relative z-20 max-w-7xl mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-4 text-white">
            Traain Exchange
          </h1>

          <h2 className="text-2xl md:text-3xl font-bold text-cyan-400 mb-4">
            The Enterprise Training Marketplace
          </h2>

          <p className="text-lg text-gray-400 mb-8">
            Powered by Traain's Navigator AI™
          </p>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed">
            Fresh, expert-led Training — continuously updated and ready to deploy.
          </p>

          <div className="mb-8">
            <p className="text-2xl md:text-3xl font-bold text-white mb-2">All Aboard.</p>
            <p className="text-lg text-gray-400">Your teams never stop moving forward.</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              onClick={openCalendly}
              className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
              data-testid="exchange-hero-explore-btn"
            >
              Explore the Exchange
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default ExchangeHero;
